import { ForgotPasswordPage } from '@online-webinar/account';
import { RouterType } from '@online-webinar/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/forgot-password'].update({
        staticData: { title: { page: 'Pages.ForgotPassword.Header', forWebinar: true } },
        component: ForgotPasswordPage
    });
};
